import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface Timezone {
  code: string;
  flag: string;
  iso2CountryCode: string;
  name: string;
  tzAbr?: string;
  flagOverride?: string;
}

export interface TimezoneWithPublisher extends Timezone {
  selectedPublisher: string;
}

export interface HeaderStore {
  timezone: TimezoneWithPublisher;
}

export const initialState = {
  timezone: {
    code: '',
    flag: '',
    iso2CountryCode: '',
    name: '',
    selectedPublisher: '',
  },
};

const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    setTimezone(state, action: PayloadAction<TimezoneWithPublisher>) {
      state.timezone = { ...action.payload };
    },
  },
});

export const { setTimezone } = headerSlice.actions;
export default headerSlice.reducer;
